import { Button, IconButton } from '@material-tailwind/react';
import { PlusIcon } from 'lucide-react';
import React, { Fragment } from 'react';

const PageHeader = ({ title, customAction, isLoading, actionOnClick, actionType = 'add', actionText = 'Add New' }) => {

    let action = '';
    if (actionType === 'add' && actionOnClick) {
        action = <Fragment>
            <IconButton disabled={isLoading} className="rounded-full lg:hidden" size="sm" onClick={actionOnClick}>
                <PlusIcon size={12} />
            </IconButton>
            <Button disabled={isLoading} className="rounded-full hidden lg:flex items-center gap-2" onClick={actionOnClick}>
                <PlusIcon size={12} /> {actionText}
            </Button>
        </Fragment>
    } else if (actionType === 'custom') {
        action = customAction;
    }
    return (
        <div className="flex justify-between items-center">
            <h1 className="md:text-2xl font-thin">{title}</h1>
            {
                action
            }
        </div>
    );
};

export default PageHeader;